<div class="flex-container">
  <div style="flex: 6">
    <h2>Settings</h2>

    <div class="column">
      <app-check-input
        [label]="'API Enabled'"
        [(ngModel)]="data.apiEnabled"
        [readonly]="this.mode == FormMode.View"
      ></app-check-input>
    </div>
    <div class="column">
      <app-text-input
        [label]="'API Key'"
        [required]="false"
        [(ngModel)]="data.apiKey"
        [readonly]="this.mode == FormMode.View"
      ></app-text-input>
    </div>
    <div class="column">
      <app-text-input
        [label]="'API Passphrase'"
        [required]="false"
        [(ngModel)]="data.apiPassphrase"
        [readonly]="this.mode == FormMode.View"
      ></app-text-input>
    </div>
    <div class="column">
      <div class="display:table-cell">
        <div style="display: table-cell">
          <app-ddl-input
            [label]="'Account Status'"
            [readonly]="this.mode == FormMode.View"
            [options]="accountStatusOptions"
            [(ngModel)]="selectedAccountStatus"
          ></app-ddl-input>
        </div>
        <div style="display: table-cell; padding-left: 20px">
          <input
            type="button"
            value="Change"
            [hidden]="this.mode == FormMode.View"
            (click)="btnChangeAccountStatus_click()"
          />
        </div>
      </div>
    </div>

    @if (this.enableEditing) {
      <div>
        @if (this.mode == FormMode.Edit) {
          <input
            class="button_primary button_var_2"
            type="button"
            value="Save"
            style="width: 200px; margin-left: 15px"
            (click)="btnSave_click()"
            (keydown.enter)="btnSave_click()"
          />
        }
        @if (this.mode == FormMode.Edit) {
          <input
            class="button_primary button_var_2"
            type="button"
            value="Cancel"
            style="width: 200px; margin-left: 15px"
            (click)="btnCancel_click()"
            (keydown.escape)="btnCancel_click()"
          />
        }
      </div>
    }
  </div>
  <div style="flex: 1; text-align: right" [hidden]="!enableEditing">
    <div
      style="
        float: right;
        background-color: #f7f7f7;
        padding: 3px;
        width: 25px;
        height: 25px;
        cursor: pointer;
      "
      title="Edit"
      [hidden]="this.mode == FormMode.Edit"
      (click)="btnEdit_click()"
    >
      <i class="fa-regular fa-pen-to-square icon"></i>
    </div>
    <div style="clear: both"></div>
  </div>
</div>
